import { CommissionStatuses } from 'constants/commissionStatuses';

import { getLastUrlSegment } from 'utils/getLastUrlSegment';

export const commissionTaskAccess = {
  canCreate: (status: CommissionStatuses) => {
    return [CommissionStatuses.Created, CommissionStatuses.Rejected].includes(
      getLastUrlSegment(status) as CommissionStatuses,
    );
  },
  canEdit: (status: CommissionStatuses) => {
    return [CommissionStatuses.Created, CommissionStatuses.Rejected].includes(
      getLastUrlSegment(status) as CommissionStatuses,
    );
  },
  canDelete: (status: CommissionStatuses) => {
    return [CommissionStatuses.Created, CommissionStatuses.Rejected].includes(
      getLastUrlSegment(status) as CommissionStatuses,
    );
  },
};
